// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Orcs.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  ArchiveOrcRequest,
  ArchiveOrcResponse,
  CreateOrcRequest,
  CreateOrcResponse,
  GetOrcsRequest,
  GetOrcsResponse,
  UpdateOrcRequest,
  UpdateOrcResponse,
} from "./Models/OrcModels";

export const protobufPackage = "daisi.protos.v1";

export type OrcsProtoDefinition = typeof OrcsProtoDefinition;
export const OrcsProtoDefinition = {
  name: "OrcsProto",
  fullName: "daisi.protos.v1.OrcsProto",
  methods: {
    get: {
      name: "Get",
      requestType: GetOrcsRequest,
      requestStream: false,
      responseType: GetOrcsResponse,
      responseStream: false,
      options: {},
    },
    update: {
      name: "Update",
      requestType: UpdateOrcRequest,
      requestStream: false,
      responseType: UpdateOrcResponse,
      responseStream: false,
      options: {},
    },
    archive: {
      name: "Archive",
      requestType: ArchiveOrcRequest,
      requestStream: false,
      responseType: ArchiveOrcResponse,
      responseStream: false,
      options: {},
    },
    create: {
      name: "Create",
      requestType: CreateOrcRequest,
      requestStream: false,
      responseType: CreateOrcResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface OrcsProtoServiceImplementation<CallContextExt = {}> {
  get(request: GetOrcsRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetOrcsResponse>>;
  update(request: UpdateOrcRequest, context: CallContext & CallContextExt): Promise<DeepPartial<UpdateOrcResponse>>;
  archive(request: ArchiveOrcRequest, context: CallContext & CallContextExt): Promise<DeepPartial<ArchiveOrcResponse>>;
  create(request: CreateOrcRequest, context: CallContext & CallContextExt): Promise<DeepPartial<CreateOrcResponse>>;
}

export interface OrcsProtoClient<CallOptionsExt = {}> {
  get(request: DeepPartial<GetOrcsRequest>, options?: CallOptions & CallOptionsExt): Promise<GetOrcsResponse>;
  update(request: DeepPartial<UpdateOrcRequest>, options?: CallOptions & CallOptionsExt): Promise<UpdateOrcResponse>;
  archive(request: DeepPartial<ArchiveOrcRequest>, options?: CallOptions & CallOptionsExt): Promise<ArchiveOrcResponse>;
  create(request: DeepPartial<CreateOrcRequest>, options?: CallOptions & CallOptionsExt): Promise<CreateOrcResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
